import { render, staticRenderFns } from "./yoWhatsappDownload.vue?vue&type=template&id=49164b36&scoped=true"
import script from "./yoWhatsappDownload.vue?vue&type=script&lang=js"
export * from "./yoWhatsappDownload.vue?vue&type=script&lang=js"
import style0 from "./yoWhatsappDownload.vue?vue&type=style&index=0&id=49164b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49164b36",
  null
  
)

export default component.exports